import cn from 'classnames'

import './Logo.scss'

export function Logo({ className }) {
    return (
        <span className={cn(className, 'logo')}>Formulaic</span>
    )
}